export const skillxDepartmentNames = ['SkillX'];
export const FOUNDATION_DEPARTMENT_ID = 3;

export const assignedToDepartment = [
  { id: 11, name: 'Operations Growth Department (OGD)' },
  { id: 12, name: 'Client Service Department' },
];

export const prospect_leads_departments = [
  { id: 12, name: 'CSD' },
  { id: 11, name: 'OGD' },
];

export const ogdDepartmentId = 11;

// Technical Department. Used to keep developer only helpers off everybody else's
// screen, so a note written for whoever maintains the code is not read as an
// instruction by the team using the page.
export const technicalDepartmentId = 5;
